/**
 * Get the corresponding cookie
 * @param name the cookie name
 * @return the cookie
 */
function getCookie(name: string): string | null {
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  const arr = document.cookie.match(reg);
  if (arr) {
    return decodeURIComponent(arr[2]);
  } else {
    return null;
  }
}

/**
 * delete the cookie storaged in the browser
 * @param name the cookie name
 */
function delCookie(name: string): void {
  const exp: Date = new Date();
  exp.setTime(exp.getTime() - 1 * 24 * 60 * 60 * 1000);
  const cval = getCookie(name);
  document.cookie =
    name + '=' + cval + '; expires=' + exp.toUTCString() + '; path=/';
}

/**
 * store the cookie value in the browser
 * @param cname the cookie name
 * @param cvalue the cookie value
 * @param exdays the expiration date of the cookie
 */
function setCookie(cname: string, cvalue: string, exdays: number): void {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + escape(cvalue) + '; ' + expires + ';path=/';
}

/**
 * 检查用户是否在白名单中,如果在则设置 ssc_user_role Cookie
 * ⚠️ 关键优化: 先检查 Cookie 是否已存在,避免重复设置和不必要的刷新
 *
 * @param userEmail - 当前用户邮箱
 * @param alertUserList - 白名单邮箱列表
 * @returns 是否新设置了 Cookie (true 表示需要刷新页面)
 */
export function checkAndSetUserRoleCookie(
  userEmail: string,
  alertUserList: string[]
): boolean {
  if (!userEmail || !alertUserList || !Array.isArray(alertUserList)) {
    return false;
  }

  // ⚠️ 关键: 先检查 Cookie 是否已存在
  // 如果后端已经设置了 Cookie (通过 HR 系统),前端不需要再设置
  const existingCookie = getCookie('ssc_user_role');
  if (existingCookie) {
    console.log(
      '[LiveTip] Cookie already exists, no need to set:',
      existingCookie
    );
    return false; // Cookie 已存在,不需要刷新
  }
  // 检查用户邮箱是否在白名单中 (不区分大小写)
  const isInWhitelist = alertUserList.some(
    (email) => email.toLowerCase() === userEmail.toLowerCase()
  );

  if (isInWhitelist) {
    // 设置 Cookie,默认值为 "FE",7天过期
    setCookie('ssc_user_role', 'FE', 7);
    console.log('[LiveTip] User in alert whitelist, cookie set:', userEmail);
    return true; // 新设置了 Cookie,需要刷新
  }

  return false;
}

export { getCookie, delCookie, setCookie };
